// extracted by mini-css-extract-plugin
export default {"accordion-usage-consolidation-header":"accordion-usage-consolidation-header---I1XkW"};